import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants"

export const initialState = {
    loading: false,
    error: null,
    groups:null,
    groupsList: null,
    selectedGroup: null,
    selectedView: INFRAMARK_CONSTANTS.groups.constants.GROUPLISTVIEW
}